import { render, staticRenderFns } from "./QrFooter.vue?vue&type=template&id=3fcca69c&scoped=true&"
import script from "./QrFooter.vue?vue&type=script&lang=ts&"
export * from "./QrFooter.vue?vue&type=script&lang=ts&"
import style0 from "./QrFooter.vue?vue&type=style&index=0&id=3fcca69c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcca69c",
  null
  
)

export default component.exports